module.exports = __webpack_public_path__ + "img/laurel.b59a2cc.svg";